import Cookies from 'js-cookie';

/**
 * @const verifyInfo - Verify Info Read/Edit should return 'Verify Information' instead.
 */
const verifyInfo = ['Verify Info Read', 'Verify Info Edit'];

/**
 *
 * @param { object } param0
 * @param { object } param0.query
 * @param { boolean } param0.mcoa - whether the Change-of-Address (COA) is a military coa.
 * @param { object } param0.meta - the meta data passed from router.
 * @param { string } param0.meta.pageName - the current page name passed from router.
 * @returns { string } - the pageName to send to analytics.
 */
const getPageName = ({ query, meta: { pageName } }) => {
  if (query?.mcoa) return 'Confirm Order MCOA';
  if (verifyInfo.includes(pageName)) return 'Verify Information';
  return pageName;
};

const getMatchMedia = () => matchMedia('screen and (min-width: 0px) and (max-width: 1023px)').matches;
export const deviceType = () => (getMatchMedia() ? 'mobile' : 'desktop');
export const isDesktop = () => getMatchMedia();
export const orderUuid = () => Cookies.get('coa') || '';

/**
 * userAgentData will be the prefered method to capture device information.
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/Navigator/userAgentData#browser_compatibility| userAgentData compatibility}
 * @return { boolean } - is device a 'desktop' device.
 */
const isMobileDevice = () => navigator.userAgentData?.mobile ?? deviceType();

export const getContext = () => ({
  context: {
    ip: '0.0.0.0',
  },
  deviceType: isMobileDevice(),
  orderUuid: orderUuid(),
  origin: 'MGO',
});
/**
 *
 * @param { window } param0
 * @param { string } param0.pathname - the navigation pathname property renamed to 'path'.
 * @param { string } param0.search - the navigation search property.
 * @param { string } param0.href - the navigation href property renamed to 'url'.
 * @returns { object }
 */
const getNavigation = ({ pathname, search, href }) => ({
  url: href,
  path: pathname,
  search,
});

export const getPageProperties = ({ title, ...args }) => ({
  ...getNavigation(window.location),
  title: title ?? document.title,
  name: getPageName(args),
});
